import { Position, TextInput as TextInputZebra } from '@trmediaab/zebra';
import type { createStyledIcon } from '@trmediaab/zebra-icons';

import { RenderInput } from './RenderInput';

type TextInputProps = React.ComponentProps<typeof TextInputZebra> & {
  label?: string;
  description?: string;
  placeholder?: string;
  name: string;
  Icon?: React.ComponentType<ReturnType<typeof createStyledIcon>>;
  onEnterKeyPress?: () => void;
};

export const TextInput = ({
  label,
  description,
  placeholder,
  name,
  Icon,
  onEnterKeyPress,
  ...props
}: TextInputProps) => (
  <RenderInput
    label={label}
    description={description}
    render={id => {
      const input = (
        <TextInputZebra
          id={id}
          name={name}
          placeholder={placeholder}
          pl={Icon != null ? '42px' : undefined}
          sx={{ '::placeholder': { color: 'text.primary' } }}
          onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
            if (e.key === 'Enter' && onEnterKeyPress != null) {
              onEnterKeyPress();
            }
          }}
          {...props}
        />
      );
      return Icon != null ? (
        <Position.relative>
          <Position.absolute
            left="3,5"
            top="50%"
            sx={{
              transform: 'translate(-50%, -50%)',
            }}
          >
            <Icon mt="-2px" size="24px" color="checkout.textInputIcon" />
          </Position.absolute>
          {input}
        </Position.relative>
      ) : (
        input
      );
    }}
  />
);
